import type { PreviewWrapperProps } from './types'

import * as S from './styles'

export const PreviewWrapper = ({ children }: PreviewWrapperProps) => {
  if (!Array.isArray(children) || !children?.length) return null

  return <S.Container>{children}</S.Container>
}
